module.exports = __webpack_public_path__ + "static/media/write_1.2f14504c.ico";